import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Trash2, MessageSquare } from "lucide-react";

export default function Inquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/inquiries").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const remove = async (i) => {
    if (!window.confirm(`Delete inquiry from ${i.name}?`)) return;
    try {
      await api.delete(`/inquiries/${i.id}`);
      setItems((xs) => xs.filter((x) => x.id !== i.id));
      toast.success("Inquiry deleted");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Delete failed");
    }
  };

  return (
    <div className="p-6 lg:p-8" data-testid="inquiries-page">
      <h1 className="text-xl font-semibold text-slate-900">Website Inquiries</h1>
      <p className="text-sm text-slate-500 mt-1">Quote requests submitted from the public Contact Us page.</p>

      {loading ? (
        <div className="mt-8 text-sm text-slate-400">Loading…</div>
      ) : items.length === 0 ? (
        <div className="mt-12 flex flex-col items-center text-slate-400 gap-2">
          <MessageSquare size={36} />
          <div className="text-sm">No inquiries yet.</div>
        </div>
      ) : (
        <div className="mt-6 bg-white border border-slate-200 rounded-xl overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-slate-500 border-b border-slate-100">
                <th className="px-4 py-3">Date</th>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Phone</th>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">Route</th>
                <th className="px-4 py-3">Message</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id} className="border-b border-slate-50 hover:bg-slate-50/60" data-testid={`inquiry-row-${i.id}`}>
                  <td className="px-4 py-3 whitespace-nowrap text-slate-500">{new Date(i.created_at).toLocaleDateString("en-IN")}</td>
                  <td className="px-4 py-3 font-medium text-slate-900">{i.name}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{i.phone}</td>
                  <td className="px-4 py-3">{i.consignment_type}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{[i.origin, i.destination].filter(Boolean).join(" → ") || "—"}</td>
                  <td className="px-4 py-3 max-w-[280px] truncate" title={i.message}>{i.message || "—"}</td>
                  <td className="px-4 py-3">
                    <button onClick={() => remove(i)} className="p-2 hover:bg-red-50 text-red-600 rounded" data-testid={`inquiry-delete-${i.id}`}>
                      <Trash2 size={15} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
